import React from "react";
import styled from "styled-components";
import { path } from "ramda";
import { Row, Col, Card, Divider } from "antd";
import I18n from "../../i18n";
import { OH1 } from "../../components/text/OText";
import { Colors, Metrics } from "../../theme";
import { DataVisualizeKeys } from "../../theme/Colors";
import { isAlive, isFunction, ArrayUtil, DateUtil, isFillAlive } from "../../util";
import DatePickerCompare from "./DatePickerCompare";
import ExportButton from "../../components/button/ExportButton";
import ExportDateRangeModal from "../../components/modal/ExportDateRangeModal";
import { HeaderOptionBar, SubHeader, TargetValueType } from "./CompareValuePanel";
import { withCompareDate } from "../../hoc/index";

class ComparePanel extends React.Component{
    state = {}
	texts = {}
	dateRange = {
		[TargetValueType.Primary]:undefined,
		[TargetValueType.Secondary]:undefined
	};
	exportModal = undefined;
	/**
     * Set primary and secondary panel here.
     */
	constructor(props){
    	super(props);
		const { setRef, getMomentReportDate } = props;
		this.dateRange = getMomentReportDate();
    	if(isFunction(setRef)){
    		setRef(this);
    	}
    	this.texts = { vs:I18n.t("vs") };
    	this.state = {
			isExporting: false,
    	};
	}
    onPrimaryDateRangeChange = (dates)=>{
    	const { onPrimaryDateChanged, saveDateRange } = this.props;
    	this.dateRange[TargetValueType.Primary] = dates;
    	saveDateRange(TargetValueType.Primary, dates);
    	this.forceUpdate(()=>{
    		if(isFunction(onPrimaryDateChanged)){
    			onPrimaryDateChanged(dates);
    		}
    	});
    }
    onSecondaryDateRangeChange = (dates)=>{
    	const { onSecondaryDateChanged, saveDateRange } = this.props;
    	this.dateRange[TargetValueType.Secondary] = dates;
    	saveDateRange(TargetValueType.Secondary, dates);
    	this.forceUpdate(()=>{
    		if(isFunction(onSecondaryDateChanged)){
    			onSecondaryDateChanged(dates);
    		}
    	});
    }
    isShowCompare(){
    	return isFillAlive(this.dateRange[TargetValueType.Secondary]);
    }
    /**
     * Enable or disable compare view mode.
     * @param {boolean} isShow 
     */
    setShowCompare(isShow){
    	this.setState({showCompare:isShow});
    }
	onExportClick = ()=>{
		const { showCompare } = this.state;
		const { 
			getExportAll,
			getExportPromise, 
			getMomentReportDate,
		} = this.props;
		const dateRange = getMomentReportDate();
		this.setState({isExporting:true},()=>{
			const promiseHandler = promise=>{
				promise.then(res=>{
					if(typeof res === "object"){
						const { url } = res;
						if(url){
							window.open(url);
						}
					}else{
						window.open(res.file);
					}
					this.setState({isExporting:false});
				}).catch(error=>{
					this.setState({isExporting:false});
				});
			};

			if(isFunction(getExportPromise)){
				promiseHandler(getExportPromise(
					dateRange[TargetValueType.Primary], 
					dateRange[TargetValueType.Secondary]
				));
			}else{
				promiseHandler(getExportAll(dateRange[TargetValueType.Primary]));
			}
		});
	}
	getDateRanges(){
		return this.dateRange;
	}
	getDateRange(type){
		return this.dateRange[type];
	}

	render(){
    	const { 
			id, header, subHeader, style, showSecondaryDatePicker, 
			getExportAll, getExportPromise, disableExport,
			beforeComponent, children,showHeaderOptionBar 
		} = this.props;
		const { isExporting } = this.state;
		const showCompare = isFillAlive(this.dateRange[TargetValueType.Secondary]);
		const dateFormat = "DD MMM YYYY";
    
		const showExport = isFunction(getExportAll) || isFunction(getExportPromise);
    	return (
    		<div id={id} style={style}>
    			{header ? <OH1>{header}</OH1> : undefined}
    			{subHeader ? <SubHeader>{subHeader}</SubHeader> : undefined}
    			{showHeaderOptionBar ?	
					<HeaderOptionBar>
    				<DatePickerCompare 
    					displayFormat={dateFormat}
    					headDate={this.dateRange[TargetValueType.Primary]}
    					tailDate={this.dateRange[TargetValueType.Secondary]}
    					onHeadDateChange={this.onPrimaryDateRangeChange}
    					onTailDateChange={this.onSecondaryDateRangeChange}
    					showTail={showSecondaryDatePicker} 
    				/>
    				{showExport ? <ExportButton 
							disabled={disableExport}
							onClick={this.onExportClick}
							loading={isExporting}
						/> : undefined}
    			</HeaderOptionBar>
					: undefined }
    			{beforeComponent}
    			{children({showCompare, dateRange:this.dateRange})}
    		</div>
    	);
	}
}

ComparePanel.defaultProps = {
	setRef:(ref)=>{},
	header:undefined,
	subHeader:undefined,
	style:undefined,
	showHeaderOptionBar:true,
	showSecondaryDatePicker:false,
	getExportAll:undefined,
	getExportPromise:undefined, 
	disableExport:false,
	onPrimaryDateChanged:(dates)=>{console.log("onHeadDateChanged: ",dates);},
	onSecondaryDateChanged:(dates)=>{console.log("onTailDateChanged: ",dates);},
	beforeComponent:undefined,
	children:(props)=>{console.log("renderChildren: ",props);}
};
export default withCompareDate(ComparePanel);


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/ComparePanel.js